import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase-client';
import { getCreateTeamUserError } from './createTeamErrorHandling';
import { waitForTeamToExist } from './createTeamReadiness';

export default function CreateTeamFormFields({
  onCancel,
  onSuccess
}) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitPhase, setSubmitPhase] = useState('idle');
  const [error, setError] = useState(null);
  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitPhase('creating');
    setError(null);
    try {
      const trimmedName = name.trim();
      if (!trimmedName) {
        setError('Add a club name.');
        return;
      }

      const createTeam = httpsCallable(functions, 'createTeam');
      const result = await createTeam({
        name: trimmedName,
        description: description.trim(),
      });
      const teamId = result?.data?.teamId;
      if (!teamId) throw new Error('Create team response did not include a team id.');

      setSubmitPhase('opening');
      await waitForTeamToExist(teamId);

      setName('');
      setDescription('');
      onSuccess?.(teamId);
    } catch (err) {
      setError(getCreateTeamUserError(err, {
        source: 'form.createTeamFields.submit',
        context: {
          hasName: Boolean(name.trim()),
          descriptionLength: description.trim().length,
        },
      }));
    } finally {
      setSubmitting(false);
      setSubmitPhase('idle');
    }
  };

  const submitLabel = submitPhase === 'opening'
    ? 'Opening club…'
    : submitting
      ? 'Creating…'
      : 'Create club';
  const statusMessage = submitPhase === 'opening'
    ? 'Setting up your club space…'
    : '';

  return <form onSubmit={handleSubmit} className="modal-form">
      {error && <div className="modal-error" role="alert">{error}</div>}
      {statusMessage && <div className="text-muted" role="status" aria-live="polite">{statusMessage}</div>}

      <input id="teamName" className="form-input w-full" placeholder="Club name" value={name} onChange={e => setName(e.target.value)} required disabled={submitting} />

      <textarea id="teamDescription" className="form-input w-full" placeholder="Description (optional)" value={description} onChange={e => setDescription(e.target.value)} rows={3} disabled={submitting} />

      <div className="form-actions">
        {onCancel && <button type="button" className="button button-secondary px-6 py-3 text-lg" onClick={onCancel} disabled={submitting}>
            Back
          </button>}
        <button type="submit" className="button button-primary px-6 py-3 text-lg" disabled={submitting}>
          {submitLabel}
        </button>
      </div>
    </form>;
}
CreateTeamFormFields.propTypes = {
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func.isRequired
};
